@if (isLoadingEmployee()) {
  <div class="w-full flex flex-row flex-nowrap justify-center items-center mt-[15%]">
    <mat-spinner></mat-spinner>
  </div>
} @else if (authFeature.isAuthenticated()) {
  <app-navigation-bar></app-navigation-bar>
} @else {
  <router-outlet></router-outlet>
}
